module.exports = __webpack_public_path__ + "img/250460827_2025_4-1.3763643d.png";